import classNames from 'classnames';
import React, { isValidElement } from 'react';
import {getChildrenText, WebUI} from "../../wui-core/src/index"
import Dropdown from '../../wui-dropdown/src/index';
import Icon from '../../wui-icon/src/index';
import { BreadcrumbItemProps } from './iBreadcrumb';

const defaultProps = {
    active: false,
};

const BreadcrumbItem: React.FC<BreadcrumbItemProps> = (props) => {
    const {
        active = false,
        className,
        separator,
        clsPrefix,
        isActiveKey,
        activeKey,
        keyValue,
        onItemClick,
        href,
        overlay: overlayProp,
        dropdownProps,
        children,
        title: titleProp,
        menu,
        ...rest
    } = props;

    let title = getChildrenText(titleProp).join('');
    let overlay = menu || overlayProp;

    const handleClick = (e: React.MouseEvent) => {
        onItemClick?.(e, keyValue as string);
    };

    const content = href ? (
        <a className={`${clsPrefix}-item-content`} {...(rest as React.AnchorHTMLAttributes<HTMLAnchorElement>)} href={href} title={title}>{children}</a>
    ) : (
        <span className={`${clsPrefix}-item-content`} {...(rest as React.HTMLAttributes<HTMLSpanElement>)} title={title}>{children}</span>
    );

    const renderContent = () => (
        overlay && isValidElement(overlay) ? (
            <Dropdown {...dropdownProps} overlay={overlay}>
                <span {...(rest as React.HTMLAttributes<HTMLSpanElement>)}>
                    {children}
                    <Icon className={`${clsPrefix}-dropdown-icon`} type="uf-arrow-down"/>
                </span>
            </Dropdown>
        ) : (
            content
        )
    );

    let isLevel = activeKey ? (isActiveKey ? isActiveKey : active) : active;
    const classNam = classNames(
        className,
        {[`${clsPrefix}-active`]: isLevel}
    );

    return (
        <li className={classNam} onClick={handleClick}>
            {renderContent()}
            {separator && <span className={`${clsPrefix}-separator`}>{separator}</span>}
        </li>
    );
};

export default WebUI({name: "breadcrumb", defaultProps})(BreadcrumbItem);
